import React, { Component, useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { Link } from 'react-router-dom';

export const CbCsoLogin = ({ containerObject, templateName, contentId, dataZone }) => {
    const [emailValue, setEmailValue, emailValueRef] = useStateRef("")
    const [emailSubmitError, setEmailSubmitError] = useState()
    const [token, setToken] = useState();
    const [redirectUrl, setRedirectUrl] = useState();
    const [gotoUrl, setGotoUrl] = useState();
    const [domain, setDomain] = useState();
    useEffect(() => {
        setDomain(containerObject && containerObject.csoLogoImageUrl)
        var searchParam = window.location.search
        const params = new URLSearchParams(searchParam);
        var emailId = params.get('email')
        if(emailId) {
        	console.log("CSO reset email  ",emailId)
        	setEmailValue(emailId)
    	    handleCsoForgotPwd();
        }
        var goto = params.get('goto')
        setGotoUrl(goto ? goto : "")
    }, []);
   

    const handleCsoForgotPwd = () => {
       
    	const formValue= { CBSSO_email: emailValueRef.current };
        console.log("formValue ",formValue)
        
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/SSO-email-submit`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                	
                		handleRedirectForgotPwd();
                	
                } else {
                    console.log("error46", res.result)
                    console.log("error47", res.errorMessage)
                    setEmailSubmitError(res.errorMessage)
                    document.getElementById("email-submit-error").classList.remove("d-none")
                    document.getElementById("email-submit-error").classList.add("d-block")
                }
            })
    }
    
    const handleEmailSubmit = (event) => {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        console.log("formValue.CBSSO_email", formValue.CBSSO_email)
        const emailVal = formValue.CBSSO_email
        setEmailValue(emailVal)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    console.log("successsss", "cso-email-submit")
                    document.getElementById("state-1").classList.add("d-none")
                    document.getElementById("state-2").classList.remove("d-none")
                    document.getElementById("state-2").classList.add("d-block")
                } else {
                    console.log("error46", res.result)
                    console.log("error47", res.errorMessage)
                    setEmailSubmitError(res.errorMessage)
                    document.getElementById("email-submit-error").classList.remove("d-none")
                    document.getElementById("email-submit-error").classList.add("d-block")
                }
            })
    }
    const handleLogin = (event) => {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        console.log("formValue.CBSSO_email", formValue.email)
        setEmailValue(formValue.email)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    const response = res.response && res.response.response;
                    const token = response && response.token;
                    setToken(token);
                    console.log("goto", gotoUrl)
                    setRedirectUrl(gotoUrl ? gotoUrl : "")
                    if (gotoUrl) {
                        handleLoginCallBack(token);
                    }
                    document.getElementById("state-1").classList.add("d-none")
                    document.getElementById("state-2").classList.remove("d-none")
                    document.getElementById("state-2").classList.add("d-block")
                } else {
                    console.log("error46", res.result)
                    console.log("error47", res.errorMessage)
                    setEmailSubmitError(res.errorMessage)
                    document.getElementById("email-submit-error-2").classList.remove("d-none")
                    document.getElementById("email-submit-error-2").classList.add("d-block")
                }
            })
    }
    const handleLoginCallBack = (token) => {
        document.getElementById("sso-redirect").click();
    }
    const handleRedirectForgotPwd = (event) => {
    	console.log("emailValueRef", emailValueRef.current);
        const inputMap = {
            email: emailValueRef.current
        }
        setEmailValue(emailValueRef.current)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/SSO-navigate-forgot-password`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    document.getElementById("state-1").classList.add("d-none")
                    document.getElementById("state-2").classList.remove("d-block")
                    document.getElementById("state-2").classList.add("d-none")
                    document.getElementById("state-3").classList.remove("d-none")
                    document.getElementById("state-3").classList.add("d-block")
                } else {
                    // console.log("error46", res.result)
                    // console.log("error47", res.errorMessage)
                    // setEmailSubmitError(res.errorMessage)
                    // document.getElementById("email-submit-error").classList.remove("d-none")
                    // document.getElementById("email-submit-error").classList.add("d-block")
                }
            })
    }
    const handleForgotPassword = (event) => {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    console.log("successsss", "cso-email-submit")
                    document.getElementById("state-1").classList.add("d-none")
                    document.getElementById("state-2").classList.remove("d-block")
                    document.getElementById("state-2").classList.add("d-none")
                    document.getElementById("state-3").classList.remove("d-block")
                    document.getElementById("state-3").classList.add("d-none")
                    document.getElementById("state-4").classList.remove("d-none")
                    document.getElementById("state-4").classList.add("d-block")
                } else {
                    console.log("error46", res.result)
                    console.log("error47", res.errorMessage)
                    setEmailSubmitError(res.errorMessage)
                    //document.getElementById("email-submit-error").classList.remove("d-none")
                    // document.getElementById("email-submit-error").classList.add("d-block")
                }
            })
    }
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            <div class="row justify-content-center cso-pages mx-1 px-md-2">
                <div class="row">
                    <div class="col-md-12">
                        <a href={domain} class="c-cso-logo">
                            <img src="/images/cso-logo.jpg" alt="Carolina Science Online" />
                        </a>
                    </div>
                    <hr />
                </div>
                <div id="state-1">
                    <form method="post" action="SSO-email-submit" id="email-form" target="_top" onSubmit={handleEmailSubmit} data-hs-cf-bound="true">

                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="c-account-list-heading mb-2">Log In</h1>
                                <p>Please enter your email address.</p>
                                <div class="alert alert-danger d-none" role="alert" id="email-submit-error">
                                    <p>
                                        {emailSubmitError}<br />
                                    </p>
                                </div>
                                <div class="mb-3 row">
                                    <label for="email" class="col-sm-2 col-form-label fw-bold">Email:</label>
                                    <div class="col-sm-6">
                                        <input maxlength="256" tabindex="1" name="CBSSO_email" defaultValue={emailValueRef.current} id="email" type="email" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row mb-4">
                            <div class="col-6 col-md-6">
                                <Link to={`/account/sso/registration?goto=${gotoUrl}`} class="c-cso-link fw-bold" tabindex="3">Register</Link>
                            </div>
                            <div class="col-6 col-md-6 text-end">
                                <button tabindex="2" name="screenUserEmail" type="submit" value="Submit" class="btn btn-primary">Submit</button>
                            </div>
                        </div>

                    </form>
                </div>
                <div id="state-2" className='d-none'>
                    <form method="post" action="SSO-login" id="password-form" target="_top" onSubmit={handleLogin} data-hs-cf-bound="true">

                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="c-account-list-heading mb-2">Log In</h1>
                                <p>Please enter your password.</p>
                                <div class="alert alert-danger d-none" role="alert" id="email-submit-error-2">
                                    <p>
                                        {emailSubmitError}<br />
                                    </p>
                                </div>
                                <div class="mb-3 row">
                                    <label for="email" class="col-sm-2 col-form-label fw-bold">Email:</label>
                                    <div class="col-sm-6">
                                        <input type="text" readonly="" name="email" defaultValue={emailValueRef.current} class="form-control-plaintext" id="email-sso" />
                                    </div>
                                </div>
                                <div class="mb-3 row my-2">
                                    <label for="password" class="col-sm-2 col-form-label fw-bold">Password:</label>
                                    <div class="col-sm-6">
                                        <input name="password" id="password" type="password" class="form-control" />
                                        <Link class="mt-2 fw-bold d-block" onClick={handleRedirectForgotPwd} >Forgot Password?</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row mb-4">
                            <div class="col-6 col-md-6">
                                <Link class="btn btn-secondary" to="/account/sso/login">
                                    Cancel
                                </Link>
                            </div>
                            <div class="col-6 col-md-6 text-end">
                                <button name="screenUserPassword" type="submit" value="Log In" class="btn btn-primary">Log In</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div id="state-3" className='d-none'>
                    <form method="post" action="SSO-forgot-password" id="reset-password" onSubmit={handleForgotPassword} target="_top" data-hs-cf-bound="true">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="c-account-list-heading mb-2">Set Password</h1>
                                <p>To set a new password, an email with an update link will be sent to the email address below.
                                    After clicking continue, check your inbox for this email and use the link to set a new password.</p>
                                <div class="mb-3 row">
                                    <label for="staticEmail" class="col-sm-2 col-form-label fw-bold">Email: *</label>
                                    <div class="col-sm-6">
                                        <input type="text" readonly="" class="form-control-plaintext" name="forgot-email" defaultValue={emailValueRef.current} id="staticEmail" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row mb-4">
                            <div class="col-6 col-md-6">
                                <Link class="btn btn-secondary" to="/account/sso/login">
                                    Cancel
                                </Link>
                            </div>
                            <div class="col-6 col-md-6 text-end">
                                <button name="forgotPassword" type="submit" value="Continue" class="btn btn-primary">Continue</button>
                            </div>
                        </div>
                    </form>
                    <form method="post" className='d-none' action={redirectUrl}>
                        <input type="hidden" id="createdToken" name="createdToken" value={token} />
                        <input type="submit" id="sso-redirect" />
                    </form>
                </div>
                <div id="state-4" className="d-none">
                    <div class="col-md-12">
                        <h1 class="c-account-list-heading mb-2">Set Password</h1>
                        <p>To set a new password, an email with an update link will be sent to the email address below.
                            After clicking continue, check your inbox for this email and use the link to set a new password.</p>
                        <p class="c-cso-success">Email has been successfully sent</p>
                    </div>
                </div>
            </div>
        </div>
    )
}